import {Tooltip} from 'platform/components';
import {useFormatNumber} from 'platform/locale';

import {isNotNil, isNumber} from 'ramda-adjunct';

import {EMPTY_CELL_PLACEHOLDER} from '../../constants/cellPlaceholder';
import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getNumericCellClassName} from '../../utils/getCellClassName';
import {getTooltipProps} from '../../utils/getTooltipProps';

type IntegerCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};

export function IntegerCellRenderer(props: IntegerCellRendererProps) {
  const className = getNumericCellClassName(props.isWrap);
  const formatNumber = useFormatNumber();
  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  if (!isNotNil(props.value)) {
    return <div className={className}>{props.emptyCellValue ?? EMPTY_CELL_PLACEHOLDER}</div>;
  }

  const decimalPlaces = isNumber(props.column.rendererParams?.decimalPlaces)
    ? props.column.rendererParams.decimalPlaces
    : 0;
  const value = formatNumber(Number(props.value), decimalPlaces);

  return (
    <Tooltip {...tooltipProps} label={value}>
      <div className={className}>{value}</div>
    </Tooltip>
  );
}
